// DO NOT UPDATE MANUALLY: Generated from script during build time
export const VERSION = '11.2.3-beta.20250410.1205';
